module.exports = __webpack_public_path__ + "media/images/avatar_mulher-00bc56b6.png";